module.exports = __webpack_public_path__ + "img/icon2.34628030.png";